import { render, staticRenderFns } from "./WebchatFront.vue?vue&type=template&id=48196f07"
import script from "./WebchatFront.vue?vue&type=script&lang=js"
export * from "./WebchatFront.vue?vue&type=script&lang=js"
import style0 from "./WebchatFront.vue?vue&type=style&index=0&id=48196f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports